import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { initializePaddle, Paddle } from '@paddle/paddle-js';

@Injectable({
  providedIn: 'root',
})
export class PaddleService {
  private paddle: Paddle | undefined;

  async initializePaddle(callback?: () => void) {
    await initializePaddle({
      environment: environment.production ? 'production' : 'sandbox',
      token: environment.paddleConfig.token,
      eventCallback: (data) => {
        if (data.name === 'checkout.completed' && callback) {
          setTimeout(() => {
            callback();
          }, 2000);
        }
      },
    }).then((paddleInstance: Paddle | undefined) => {
      if (paddleInstance) {
        this.paddle = paddleInstance;
      }
    });
  }

  private purchaseProduct(accountId: string, priceId: string) {
    this.paddle?.Checkout.open({
      customData: { accountId: accountId },
      items: [
        {
          priceId: priceId,
          quantity: 1, // always 1
        },
      ],
    });
  }

  switchToCinchMonthly(accountId: string) {
    this.purchaseProduct(
      accountId,
      environment.paddleConfig.switchToCinchMonthlyId,
    );
  }

  switchToCinchAnnually(accountId: string) {
    this.purchaseProduct(
      accountId,
      environment.paddleConfig.switchToCinchAnnuallyId,
    );
  }

  addExtraWorkspacesMonthly(accountId: string) {
    this.purchaseProduct(
      accountId,
      environment.paddleConfig.addExtraWorkspacesMonthlyId,
    );
  }

  addExtraWorkspacesAnnually(accountId: string) {
    this.purchaseProduct(
      accountId,
      environment.paddleConfig.addExtraWorkspacesAnnuallyId,
    );
  }

  addExtraChannelsMonthly(accountId: string) {
    this.purchaseProduct(
      accountId,
      environment.paddleConfig.addExtraChannelsMonthlyId,
    );
  }

  addExtraChannelsAnnually(accountId: string) {
    this.purchaseProduct(
      accountId,
      environment.paddleConfig.addExtraChannelsAnnuallyId,
    );
  }
}
